export const SEARCH_CARDS = "supportui/CardPage/SEARCH_CARDS";
export const SEARCH_CARDS_FAILED = "supportui/CardPage/SEARCH_CARDS_FAILED";
export const SEARCH_CARDS_SUCCEEDED =
  "supportui/CardPage/SEARCH_CARDS_SUCCEEDED";
